import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../../utility/getTemplateData';
import { DropdownMenu } from '@paypalcorp/pp-react-dropdown-menu';
import * as FPT from '../../utility/fpt';
import * as AppActions from '../../actions/AppActions';
import appStore from '../../stores/AppStore';
const messages = localsMessages('common/programs');

const Programs = ({ programNames, isDisabled }) => {
  const [selectedIdx, handleSelect] = useState(0);

  const getProgramOptions = () => {
    const options = [];
    programNames.forEach((programName) => {
      options.push({
        primaryText: programName,
      });
    });

    return options;
  };

  const updateProgramId = (index) => {
    handleSelect(index);
    const selectedProgram = index === -1 ? '' : programNames[index];
    AppActions.updateSelectedProgram(selectedProgram);
    FPT.trackLinkClickWithData('campaignSelected', {
      campaign: selectedProgram,
    });
  };

  useEffect(() => {
    let programOption = getProgramOptions().findIndex(
      (program) => program.primaryText === appStore.getSelectedProgram()
    );
    programOption = programOption === -1 ? 0 : programOption;
    handleSelect(programOption);
    AppActions.updateSelectedProgram(programNames[programOption]);
  }, []);

  return (
    <DropdownMenu
      id="programs"
      label={messages.programs.optional}
      className="dropdown-wide mt-16 mb-16"
      data-testid="programs-drowpdown"
      options={getProgramOptions()}
      selectedItemIndex={selectedIdx}
      onSelection={updateProgramId}
      disabled={isDisabled || false}
    />
  );
};

Programs.propTypes = {
  programNames: PropTypes.array,
  isDisabled: PropTypes.bool,
};

export default Programs;
